var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.58333 0.416748H13.4167C13.5714 0.416748 13.7197 0.478206 13.8291 0.587603C13.9385 0.696999 14 0.845372 14 1.00008C14 1.15479 13.9385 1.30316 13.8291 1.41256C13.7197 1.52196 13.5714 1.58341 13.4167 1.58341H7.58333H0.583333C0.428624 1.58341 0.280251 1.52196 0.170854 1.41256C0.0614582 1.30316 0 1.15479 0 1.00008C0 0.845372 0.0614582 0.696999 0.170854 0.587603C0.280251 0.478206 0.428624 0.416748 0.583333 0.416748H7.58333Z","fill":"current"}));
}

MinusInline.defaultProps = {"width":"14","height":"2","viewBox":"0 0 14 2","fill":"none"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
